<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("projects.info") }}</h5>
    <EditProject
      :tenantId="tenantId"
      :projectId="projectId"
      :company="company"
      :isSecondaryUse="isSecondaryUse"
      :plan="plan"
    />
    <hr />
    <DomainProject
      :key="domainProjectKey"
      :tenantId="tenantId"
      :projectId="projectId"
      :useDomain="useDomain"
      :company="company"
      :useCount="useCount"
      :isSecondaryUse="isSecondaryUse"
      @refreshParent="refresh"
    />
    <hr />
    <MemberProject
      :key="memberProjectKey"
      :tenantId="tenantId"
      :projectId="projectId"
      :useDomain="useDomain"
      :company="company"
      :useCount="useCount"
    />
    <hr />
    <div v-if="userRole === 'admin'">
      <h6 class="title is-6">{{ $t("projects.delete") }}</h6>
      <p style="margin-bottom: 64px;">
        <router-link
          :to="{
            name: 'projectDelete',
            params: { projectId: projectId },
          }"
          class="has-text-danger"
        >
          {{ $t("projects.deleteLink") }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import DomainProject from "@/components/projects/DomainProject.vue";
import EditProject from "@/components/projects/EditProject.vue";
import MemberProject from "@/components/projects/MemberProject.vue";
import imsr from "@/imsr-api";
import { computed, ref } from "@vue/reactivity";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    EditProject,
    MemberProject,
    Breadcrumb,
    DomainProject,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const company = ref("");
    const isSecondaryUse = ref(false);
    const useDomain = ref("");
    const useCount = ref(0);
    const plan = ref("standard");
    const memberProjectKey = ref(0);
    const domainProjectKey = ref(0);
    const breadcrumb = [
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: store.getters.projectId },
        },
      },
      { title: "Project", path: "#", isActive: true },
    ];

    const getTenant = async () => {
      try {
        const params = {
          tenantId: store.getters.tenantId,
        };
        const res = await imsr.imsrGetApi("/tenants", params);
        company.value = res.company;
        useDomain.value = res.useDomain;
        useCount.value = res.useCount;
        plan.value = res.plan;
        if (res.secondaryUse == true && store.getters.userRole == "admin") {
          isSecondaryUse.value = true;
        }
      } catch (e) {
        isSecondaryUse.value = false;
      }
    };
    getTenant();

    const refresh = () => {
      getTenant();
      memberProjectKey.value += 1;
      domainProjectKey.value += 1;
    };

    return {
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
      userRole: computed(() => store.getters.userRole),
      breadcrumb,
      company,
      isSecondaryUse,
      useDomain,
      useCount,
      plan,
      refresh,
      memberProjectKey,
      domainProjectKey,
    };
  },
};
</script>
